export default __webpack_public_path__ + "static/media/amazon-logo-s.6d115ddf.svg";